import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { BtnTooltipModel } from 'src/app/core/models/btn.tooltip.model';
import { Numbers } from 'src/app/utils/constants';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-upload-doc',
  templateUrl: './upload-doc.component.html',
  styleUrls: ['./upload-doc.component.scss']
})
export class UploadDocComponent implements OnInit {
  @Input() FORM_DATA: FormGroup;
  @Input() FORM_CONFIG: any;
  @Output() UPLOAD: EventEmitter<any> = new EventEmitter();

  tooltip: BtnTooltipModel;
  files: any = [];
  insureSelected: string;
  sendData = false;
  insured: any;
  errorReq = false;
  errorNum = false;
  errorLim = false;

  /**
   * @description constructor
   */
  constructor() { }
  /**
   * @description metodo inicio
   */
  ngOnInit(): void {
    this.tooltip = new BtnTooltipModel({
      label: 'icon icon-info',
      title: 'upload.tooltip',
      placement: 'right'
    });
  }
  /**
   * @description my uploader
   * @params event
   */
  myUploader(event: any): void {
    if (event.files.length === 1) {
      this.errorLim = false;
      // si solo hay un archivo subido, lo leemos, validamos y formateamos el contenido a json
      const READER: FileReader = new FileReader();
      READER.readAsBinaryString(event.files[0]);
      READER.onload = (e: any) => {
        /* create workbook */
        const BINARYSTR: string = e.target.result;
        const WB: XLSX.WorkBook = XLSX.read(BINARYSTR, { type: 'binary' });
        /* selected the first sheet */
        const WSNAME: string = WB.SheetNames[0];
        const WS: XLSX.WorkSheet = WB.Sheets[WSNAME];

        /* save data */
        const DATA: unknown[] = XLSX.utils.sheet_to_json(WS, { header: 1 }); // to get 2d array pass 2nd parameter as object {header: 1}
        // console.log('datos excel', data); // Data will be logged in array format containing objects

        // validar que el excel trae el num de col y rows apropiado
        this.getProductChoosed();
        if (this.FORM_DATA.value[this.insureSelected].numberOfInsured.id === DATA.length) {
          this.errorNum = false;
          DATA.forEach((row: Array<any>) => {
            if (row.length < Numbers.number6) {
              this.errorReq = true;
            } else {
              this.sendData = true;
              this.errorReq = false;
              this.insured = DATA;
            }
          });

          if (this.sendData === true) {
            // hay que emitir un json formateado con los datos de cada asegurado
            this.UPLOAD.emit(this.insured);
            // console.log('form', this.FORM_DATA.value[this.insureSelected].numberOfInsuredList);
          }

        } else {
          this.errorNum = true;
        }
      };

      this.files = [];
    } else {
      this.errorLim = true;
    }
  }
  /**
   * @description recupara producto
   */
  getProductChoosed(): void {
    if (this.FORM_DATA) {

      this.insureSelected = this.FORM_CONFIG.linkFormPath[0];
    }
  }
  /**
   * @description borrar documento
   */
  removeDoc(): void {
    this.errorNum = false;
    this.errorReq = false;
    this.files = [];
  }

}
